import React from "react";
import { useReportTemplateContext } from "../ReportTemplate/ReportTemplateContext";

const CATEGORY_ORDER = [
  "Rakennetekniikka",
  "LVI Järjestelmät",
  "Sähköjärjestelmät",
  "Muu",
  "Lisätutkimukset"
];

function sortCategories(grouped) {
  return Object.entries(grouped).sort(([a], [b]) => {
    const ia = CATEGORY_ORDER.indexOf(a);
    const ib = CATEGORY_ORDER.indexOf(b);

    if (ia !== -1 && ib !== -1) return ia - ib;
    if (ia !== -1) return -1;
    if (ib !== -1) return 1;

    return a.localeCompare(b);
  });
}

function renderGroupedItems(grouped) {
  return sortCategories(grouped).map(([category, items]) => (
    <div key={category} className="mb-3">
      <h6 className="fw-bold">{category}</h6>
      <ul>{items.map(i => <li key={`${i.id}-${i.sectionId}`}>{i.text}</li>)}</ul>
    </div>
  ));
}

export default function YhteenvetoToimenpideBlock() {
  const { groupedToimenpiteet = {} } = useReportTemplateContext();

  const immediateGrouped = groupedToimenpiteet.immediate || {};
  const significantGrouped = groupedToimenpiteet.significant || {};
  const tutkimusGrouped = groupedToimenpiteet.tutkimus || {};

  return (
    <div className="bg-white p-3 rounded shadow-sm mt-3">
      {/* IMMEDIATE */}
      <h5 className="text-danger mb-2">Välittömästi korjattavat</h5>
      {Object.keys(immediateGrouped).length > 0
        ? renderGroupedItems(immediateGrouped)
        : <p className="text-muted small mb-3">Ei välittömiä toimenpiteitä.</p>}

      {/* SIGNIFICANT */}
      <h5 className="text-warning mb-2">Merkittävät toimenpiteet</h5>
      {Object.keys(significantGrouped).length > 0
        ? renderGroupedItems(significantGrouped)
        : <p className="text-muted small mb-3">Ei merkittäviä toimenpiteitä.</p>}

    </div>
  );
}
